// extracted by mini-css-extract-plugin
module.exports = {"container":"_1mSqG4B4O5sswOlMKlCnF1","mainPanel":"vXeCZJ37ujTJxexjMrLnY","selectedPanel":"_2OQ9npypkotVNTMQ6m4Now"};